import { Image } from 'antd';

export default function HorizontalDialog({ text, fontSize }) {
    return (
        <>
            <Image preview={false} width={"150px"} src='activation/Lilly.png' />
            <div className='horizontalDialog'>
                <Image preview={false} src='activation/DialogBubbleHorizontal.svg' />
                <p
                    style={{
                        position: "absolute",
                        fontWeight: 600,
                        lineHeight:"normal",
                        fontSize: fontSize ? fontSize : "1vw",
                        color: "#212121",
                    }}>
                    {text}
                </p>
            </div>
        </>
    )
}